import { NotificationFilterTab } from '../../../../ui-components/lib/notification/notifications-type.enum';
import { TableFilterTab } from '../../../../ui-components/lib/table/table.model';

export const NOTIFICATION_FILTER_TABS: TableFilterTab[] = [
  {
    key: NotificationFilterTab.UNREAD,
    identifier: NotificationFilterTab.UNREAD,
    label: 'notification_tab_unread',
    active: true,
    count: 0,
  },
  {
    key: NotificationFilterTab.ALL,
    identifier: NotificationFilterTab.ALL,
    label: 'notification_tab_all',
    active: false,
    count: 0,
  },
];
